import { combineReducers } from 'redux';
import api_key from './api_key';
import accountlessAppEntry from './accountlessAppEntry';
import user from './user';
import profile from './profile';
import account from './account';
import account_by_type from './account_by_type';
import account_verification from './account_verification';
import advisory_agreements from './advisory_agreements';
import agreements from './agreements';
import cards from './cards';
import cards_by_ticker from './cards_by_ticker';
import funding_source from './funding_source';
import funding_source_by_type from './funding_source_by_type';
import investor_application from './investor_application';
import investor_application_questions from './investor_application_questions';
import eligible_account_types from './eligible_account_types';
import bank_account from './bank_account';
import quotes from './quotes';
import invest_accounts from './invest_accounts';
import tax_document from './tax_document';
import statement from './statement';
import trade_confirmations from './trade_confirmations';
import fully_paid_securities_lending_confirmations from './fully_paid_securities_lending_confirmations';
import account_history from './account_history';
import referralsHomeView from './referralsHomeView';
import bookmarks from './bookmarks';
import bank from './harmonyBank';
import notifications from './notifications';
import transfers from './transfers';
import recurringTransfer from './recurringTransfers';
import launch_info from './launch_info';
import subscriptionActions from './subscriptionActions';
import externalAccount from './externalAccount';
import income from './income';
import buy_sources from './buy_sources';
import buy_destinations from './buy_destinations';
import buy_capabilities from './buy_capabilities';
import pxQuestions from './pxQuestions';

export default combineReducers({
	api_key,
	accountlessAppEntry,
	account_verification,
	advisory_agreements,
	account,
	account_by_type,
	account_history,
	agreements,
	bank,
	bank_account, //FIME: move under account
	bookmarks,
	cards,
	cards_by_ticker,
	funding_source,
	funding_source_by_type,
	investor_application,
	investor_application_questions,
	eligible_account_types,
	launch_info,
	profile,
	invest_accounts,
	quotes,
	referralsHomeView,
	statement,
	tax_document,
	trade_confirmations,
	fully_paid_securities_lending_confirmations,
	transfers,
	user,
	notifications,
	recurringTransfer,
	subscriptionActions,
	externalAccount,
	income,
	buy_sources,
	buy_destinations,
	buy_capabilities,
	pxQuestions,
});
